import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Loader2 } from 'lucide-react';
import { authApi } from '../api/client';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError(null);
    try {
      await authApi.login(username, password);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err.error || err.message || 'Incorrect username or password');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-1 p-4">
      <form onSubmit={handleSubmit} className="w-full max-w-sm card p-6 space-y-4">
        <div className="flex flex-col items-center gap-2 text-center">
          <div className="w-10 h-10 rounded-xl bg-accent-purple/10 flex items-center justify-center">
            <Lock size={18} className="text-accent-purple" />
          </div>
          <h1 className="text-base font-semibold text-slate-900">Cloud Release Portal</h1>
          <p className="text-xs text-slate-500">Sign in to continue.</p>
        </div>

        <input
          type="text"
          autoFocus
          className="input"
          placeholder="Username"
          autoComplete="username"
          value={username}
          onChange={e => setUsername(e.target.value)}
        />

        <input
          type="password"
          className="input"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={e => setPassword(e.target.value)}
        />

        {error && <p className="text-xs text-red-500">{error}</p>}

        <button
          type="submit"
          disabled={loading || !username || !password}
          className="btn-primary w-full justify-center disabled:opacity-40"
        >
          {loading && <Loader2 size={14} className="animate-spin" />}
          {loading ? 'Checking…' : 'Continue'}
        </button>
      </form>
    </div>
  );
}
